<template>
  <ul class="d-block list-unstyled products-group prodcut-list-view">
    <li
      class="card mb-5 overflow-hidden"
      v-for="(hotelObj,hotelIndex) in lsHotels"
      :key="hotelIndex"
    >
      <div class="product-item__outer w-100" >
        <div class="row">
          <div class="col-md-5 col-xl-4">
            <div class="product-item__header">
              <div class="position-relative">
                <!-- <div
                                class="js-slick-carousel u-slick u-slick--equal-height"
                                data-slides-show="1"
                                data-slides-scroll="1"
                                data-arrows-classes="d-none d-lg-inline-block u-slick__arrow-classic v4 u-slick__arrow-classic--v4 u-slick__arrow-centered--y rounded-circle"
                                data-arrow-left-classes="flaticon-back u-slick__arrow-classic-inner u-slick__arrow-classic-inner--left"
                                data-arrow-right-classes="flaticon-next u-slick__arrow-classic-inner u-slick__arrow-classic-inner--right"
                                data-pagi-classes="js-pagination text-center u-slick__pagination u-slick__pagination--white position-absolute right-0 bottom-0 left-0 mb-3 mb-0"
                              >
                                <div class="js-slide">
                                  <a
                                    href="../hotels/hotel-single-v1.html"
                                    class="d-block gradient-overlay-half-bg-gradient-v5"
                                  >
                                    <img
                                      class="img-fluid min-height-230 card-img-top"
                                      src="@imgPathB2c/b2c/img/300x230/img58.jpg"
                                    />
                                  </a>
                                </div>
                                <div class="js-slide">
                                  <a
                                    href="../hotels/hotel-single-v1.html"
                                    class="d-block gradient-overlay-half-bg-gradient-v5"
                                  >
                                    <img
                                      class="img-fluid min-height-230 card-img-top"
                                      src="@imgPathB2c/b2c/img/300x230/img59.jpg"
                                    />
                                  </a>
                                </div>
                                <div class="js-slide">
                                  <a
                                    href="../hotels/hotel-single-v1.html"
                                    class="d-block gradient-overlay-half-bg-gradient-v5"
                                  >
                                    <img
                                      class="img-fluid min-height-230 card-img-top"
                                      src="@imgPathB2c/b2c/img/300x230/img60.jpg"
                                    />
                                  </a>
                                </div>
                                <div class="js-slide">
                                  <a
                                    href="../hotels/hotel-single-v1.html"
                                    class="d-block gradient-overlay-half-bg-gradient-v5"
                                  >
                                    <img
                                      class="img-fluid min-height-230 card-img-top"
                                      src="@imgPathB2c/b2c/img/300x230/img61.jpg"
                                    />
                                  </a>
                                </div>
                                <div class="js-slide">
                                  <a
                                    href="../hotels/hotel-single-v1.html"
                                    class="d-block gradient-overlay-half-bg-gradient-v5"
                                  >
                                    <img
                                      class="img-fluid min-height-230 card-img-top"
                                      src="@imgPathB2c/b2c/img/300x230/img62.jpg"
                                    />
                                  </a>
                                </div>
                                <div class="js-slide">
                                  <a
                                    href="../hotels/hotel-single-v1.html"
                                    class="d-block gradient-overlay-half-bg-gradient-v5"
                                  >
                                    <img
                                      class="img-fluid min-height-230 card-img-top"
                                      src="@imgPathB2c/b2c/img/300x230/img63.jpg"
                                    />
                                  </a>
                                </div>
                </div>-->
                <VueSlickCarousel :ref="'slider'" @beforeChange="onBeforeChangeCarousel(arguments,$event,hotelIndex)"
                  v-bind="settings"
                  class="js-slick-carousel u-slick u-slick--equal-height"
                >
                  <template #prevArrow="arrowOption">
                    <div
                      class="js-prev d-none d-lg-inline-block u-slick__arrow-classic v4 u-slick__arrow-classic--v4 u-slick__arrow-centered--y rounded-circle flaticon-back u-slick__arrow-classic-inner u-slick__arrow-classic-inner--left"
                    ></div>
                  </template>
                  <template #nextArrow="arrowOption">
                    <div
                      class="js-next d-none d-lg-inline-block u-slick__arrow-classic v4 u-slick__arrow-classic--v4 u-slick__arrow-centered--y rounded-circle flaticon-next u-slick__arrow-classic-inner u-slick__arrow-classic-inner--right"
                    ></div>
                  </template>
                  <template #customPaging="page">
                    <ul
                      class="js-pagination text-center u-slick__pagination u-slick__pagination--white  right-0 bottom-0 left-0 mb-3 mb-0"
                      style
                      role="tablist"
                    >
                    <!-- <li role="presentation"> -->
                                              <span></span>

                    <!-- </li> -->
                     
                      <!-- <li role="presentation" :class="{'slick-active-right slick-active slick-current':slider.nextSlide==i&&slider.compIndex==hotelIndex}">
                        <span></span>
                      </li> -->
                      
                    </ul>
                     <!-- <div class="custom-dot">
        {{ page }}
      </div> -->
                  </template>
                  <div class="js-slide">
                    <a
                      href="../hotels/hotel-single-v1.html"
                      class="d-block gradient-overlay-half-bg-gradient-v5"
                    >
                      <img
                        class="img-fluid min-height-230 card-img-top"
                        src="@imgPathB2c/b2c/img/300x230/img58.jpg"
                      />
                    </a>
                  </div>
                  <div class="js-slide">
                    <a
                      href="../hotels/hotel-single-v1.html"
                      class="d-block gradient-overlay-half-bg-gradient-v5"
                    >
                      <img
                        class="img-fluid min-height-230 card-img-top"
                        src="@imgPathB2c/b2c/img/300x230/img59.jpg"
                      />
                    </a>
                  </div>
                  <div class="js-slide">
                    <a
                      href="../hotels/hotel-single-v1.html"
                      class="d-block gradient-overlay-half-bg-gradient-v5"
                    >
                      <img
                        class="img-fluid min-height-230 card-img-top"
                        src="@imgPathB2c/b2c/img/300x230/img60.jpg"
                      />
                    </a>
                  </div>
                  <div class="js-slide">
                    <a
                      href="../hotels/hotel-single-v1.html"
                      class="d-block gradient-overlay-half-bg-gradient-v5"
                    >
                      <img
                        class="img-fluid min-height-230 card-img-top"
                        src="@imgPathB2c/b2c/img/300x230/img61.jpg"
                      />
                    </a>
                  </div>
                  <div class="js-slide">
                    <a
                      href="../hotels/hotel-single-v1.html"
                      class="d-block gradient-overlay-half-bg-gradient-v5"
                    >
                      <img
                        class="img-fluid min-height-230 card-img-top"
                        src="@imgPathB2c/b2c/img/300x230/img62.jpg"
                      />
                    </a>
                  </div>
                  <div class="js-slide">
                    <a
                      href="../hotels/hotel-single-v1.html"
                      class="d-block gradient-overlay-half-bg-gradient-v5"
                    >
                      <img
                        class="img-fluid min-height-230 card-img-top"
                        src="@imgPathB2c/b2c/img/300x230/img63.jpg"
                      />
                    </a>
                  </div>
                </VueSlickCarousel>
              </div>
            </div>
          </div>
          <div class="col-md-7 col-xl-5 col-wd-4gdot5 flex-horizontal-center" @click="onClickHotelCard(hotelObj)">
            <div class="w-100 position-relative m-4 m-md-0">
              <div class="mb-1 pb-1">
                <span
                  class="badge badge-orange text-white rounded-xs font-size-13 py-1 p-xl-2"
                >Limited Time Offer</span>
                <span class="green-lighter ml-2">
                  <small class="fas fa-star font-size-10"></small>
                  <small class="fas fa-star font-size-10"></small>
                  <small class="fas fa-star font-size-10"></small>
                  <small class="fas fa-star font-size-10"></small>
                  <small class="fas fa-star font-size-10"></small>
                </span>
              </div>

              <div class="position-absolute top-0 right-0 pr-md-3 d-none d-md-block">
                <button
                  type="button"
                  class="btn btn-sm btn-icon rounded-circle"
                  data-toggle="tooltip"
                  data-placement="top"
                  title
                  data-original-title="Save for later"
                >
                  <span class="flaticon-heart-1 font-size-20"></span>
                </button>
              </div>
              <a href="../hotels/hotel-single-v1.html">
                <span
                  class="font-weight-medium font-size-17 text-dark d-flex mb-1"
                >{{hotelObj.name}}</span>
              </a>
              <div class="card-body p-0">
                <a href="../hotels/hotel-single-v1.html" class="d-block mb-3">
                  <div
                    class="d-flex flex-wrap flex-xl-nowrap align-items-center font-size-14 text-gray-1"
                  >
                    <i class="icon flaticon-placeholder mr-2 font-size-20"></i>
                    {{hotelObj.location.address.cityName+', '}}{{hotelObj.location.address.countryCode}}
                    <small
                      class="px-1 font-size-15"
                    >-</small>
                    <span class="text-primary font-size-14">View on map</span>
                  </div>
                </a>
                <ul class="list-unstyled mb-2 d-md-flex flex-lg-wrap flex-xl-nowrap">
                  <li
                    class="border border-dark rounded-xs d-flex align-items-center text-lh-1 py-1 px-2 mr-md-2 mb-2 mb-md-0 mb-lg-2 mb-xl-0"
                  >
                    <span class="font-weight-normal font-size-14">Breakfast</span>
                  </li>
                  <li
                    class="border border-dark rounded-xs d-flex align-items-center text-lh-1 py-1 px-2 mr-md-2 mb-2 mb-md-0 mb-lg-2 mb-xl-0 mb-md-0"
                  >
                    <span class="font-weight-normal font-size-14">Free Cancellation</span>
                  </li>
                  <li
                    class="border border-dark rounded-xs d-flex align-items-center text-lh-1 py-1 px-2 mb-2 mb-md-0"
                  >
                    <span class="font-weight-normal font-size-14">Pay at the hotel</span>
                  </li>
                </ul>
                <ul class="list-unstyled d-md-flex">
                  <li
                    class="border border-green bg-green rounded-xs d-flex align-items-center text-lh-1 py-1 px-3 mb-2 mb-md-0"
                  >
                    <span class="font-weight-normal font-size-14 text-white">Lowest price includes</span>
                  </li>
                  <li
                    class="border border-green rounded-xs d-flex align-items-center text-lh-1 py-1 px-3 ml-md-n1 mb-2 mb-md-0"
                  >
                    <span class="font-weight-normal font-size-14 text-green">Free breakfast</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            class="col col-xl-3 col-wd-3gdot5 align-self-center py-4 py-xl-0 border-top border-xl-top-0"
          @click="onClickHotelCard(hotelObj)"
          >
            <div
              class="d-xl-flex flex-wrap border-xl-left ml-4 ml-xl-0 pr-xl-3 pr-wd-5 text-xl-right justify-content-xl-end"
            >
              <div class="mb-xl-5 mb-wd-7">
                <div class="mb-0">
                  <div class="my-xl-1">
                    <div class="d-flex align-items-center justify-content-xl-end mb-2">
                      <span
                        class="badge badge-primary rounded-xs font-size-14 p-2 mr-2 mb-0"
                      >{{hotelObj.rating+'/5'}}</span>
                      <span class="font-size-17 font-weight-bold text-primary">Very Good</span>
                    </div>
                  </div>
                  <span class="font-size-14 text-gray-1">(1,186 Reviews)</span>
                </div>
                <span class="font-size-14 pl-xl-2">"Great value" "Excellent location"</span>
              </div>
              <div class="mb-0">
                <span class="mr-1 font-size-14 text-gray-1">From</span>
                <span class="font-weight-bold" v-if="hotelObj&&hotelObj.rooms&&hotelObj.rooms[0].price.totalAmount">£{{hotelObj.rooms[0].price.totalAmount}}</span>
                <span class="font-size-14 text-gray-1">/ night</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import { COMPONENT_NAME } from '../../../../util/constants';
import Logger from '../../../../services/logger';
import { LOG_TYPE } from '../../../../config/API_DATA';
import BaseConfiguration from '../../../../config/base';
// import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css' ;

export default {
  name:COMPONENT_NAME.C_HOTEL_LIST_VIEW,
     components: {
         VueSlickCarousel
     },
  props: {
    lsHotels: {
      type: Array,
      default:[]
    }
  },
   data: () => ({
    settings: {
      lazyLoad: "ondemand",
      dots: true,
      dotsClass:
        "js-pagination js-pagination text-center u-slick__pagination u-slick__pagination--white position-absolute right-0 bottom-0 left-0 mb-3 mb-0",
      // dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      // useTransform:true,
      // unslick:true,
      // rtl:false
        // "fade": true,
        swipeToSlide:true

    },
    slider:{
      currentSlide:0,
      nextSlide:0,
      compIndex:0
    }
    
    }),
    methods:{
        onClickHotelCard(pHotelObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("onClickHotelCard");
       
       this.$emit('navToRoomSearch',pHotelObj);
      } catch (err) {
        let body = Logger.buildRequest(
           COMPONENT_NAME.C_HOTEL_LIST_VIEW,
          "error in onClickHotelCard",
          err.toString(),
          "onClickHotelCard",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

      onBeforeChangeCarousel(pArguments,pNextSlide,pHotelIndex) {
          try {
            if(BaseConfiguration.isDebug) console.log("onBeforeChangeCarousel");
            
          this.slider={
            currentSlide:pArguments[0],
            nextSlide:pArguments[1],
            compIndex:pHotelIndex
          }
          // console.error(this.slider.currentSlide, this.slider.nextSlide,this.slider.compIndex)

          } catch (err) {
                  let body = Logger.buildRequest(
                   COMPONENT_NAME.C_HOTEL_LIST_VIEW,
                    "error in onBeforeChangeCarousel",
                    err.toString(),
                    "onBeforeChangeCarousel",
                    LOG_TYPE.ERROR
                  );
                  Logger.getResponse(body);
                }
          }, 
    }
};
</script>
<style scoped>

/*------------------------------------
  Slick Pagination
------------------------------------*/
/* .u-slick__pagination {
  padding-left: 0;
}

.u-slick__pagination:not(.u-slick__pagination--block) {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
      justify-content: center;
  -ms-flex-align: center;
      align-items: center;
  pointer-events: none;
}

.u-slick__pagination li {
  display: -ms-flexbox;
  display: flex;
  pointer-events: all;
  margin: 0 .25rem;
  cursor: pointer;
}

.u-slick__pagination li span {
  display: inline-block;
  width: .9375rem;
  height: .9375rem;
  box-sizing: border-box;
  background-color: #e1dfca;
  border: 2px solid transparent;
  border-radius: 50%;
  -webkit-transform: scale(0.6);
          transform: scale(0.6);
  transition: 0.3s ease-in-out;
}

.u-slick__pagination li.slick-active span {
  background-color: transparent;
  border-color: #297cbb;
  -webkit-transform: scale(0.9);
          transform: scale(0.9);
}

/* White Version */
/* .u-slick__pagination--white li span {
  width: 8px;
  height: 8px;
  background-color: rgba(91, 118, 124, 0.4);
  color: rgba(255, 255, 255, 0.4);
  -webkit-transform: none;
          transform: none;
  border-width: 0;
}

.u-slick__pagination--white li.slick-active span {
  border-color: none;
  background-color:white;
} */ 

/* Block */
/* .u-slick__pagination--block li {
  display: block;
} */
</style>
